<template>
    <div class="container-fluid">
        <div class="row pt-3">
            <div class="col-md-12 designRowOrga">
                <div class="h3Organization mb-3">
                    <router-link class="back-route h3" ref="backBtn" to="/user-competitions">
                        <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                        Competition
                    </router-link>
                </div>
                <div class="">
                    <div v-if="isCompetionEnded && (!competition.is_submited && !competition.is_user_submit)">
                        <button @click.prevent="StartCompetition" class="btn-container">
                            Start Competition
                        </button>
                    </div>
                    <div v-else></div>
                </div>
            </div>
        </div>

        <div class="row tabContent">
            <div class="tabContent1  mb-5">
                <div class="">
                    <h3>Start Date</h3>
                    <h5>{{competition.start_date}}</h5>
                </div>
                <div class="">
                    <h3>End Date</h3>
                    <h5>{{competition.end_date}}</h5>
                </div>
                <div class="">
                    <h3>Start Time</h3>
                    <h5>{{competition.start_time}} GMT</h5>
                </div>
                <div class="">
                    <h3>Duration</h3>
                    <h5>{{competition.duration}} minutes</h5>
                </div>
                <vue-countdown v-if="(startCountflag && !isCompetionEnded)" @start="onCountdownStart" @end="onCountdownEnd" :time="diffTime"
                               v-slot="{ days, hours, minutes, seconds }">
                    <div class="d-flex gap-3">
                        <div class="daysCss text-center">
                            <h5>{{days >= 10 ? days : '0'+ days}}</h5>
                            <p>Days</p>
                        </div>

                        <div class="columnCss">:</div>

                        <div class="minsCss text-center">
                            <h5>{{hours > 10 ? hours : '0'+ hours}}</h5>
                            <span>Hours</span>
                        </div>

                        <div class="columnCss">:</div>

                        <div class="minsCss text-center">
                            <h5>{{minutes >= 10 ? minutes : '0'+ minutes}}</h5>
                            <span>Minutes</span>
                        </div>

                        <div class="columnCss">:</div>

                        <div class="minsCss text-center">
                            <h5>{{seconds >= 10 ? seconds : '0'+ seconds}}</h5>
                            <span>Seconds</span>
                        </div>

                    </div>
                </vue-countdown>
            </div>

            <p class="px-0" style="color: #E37450">Template Description</p>
            <div class="tabContent2 mb-3">
                <div class="col-md-12 desc">
                    {{template.description}}
                </div>
            </div>

            <p class="px-0" style="color: #E37450">Template Questions</p>
            <div class="tabContent3 mb-3">
                <div class="col-md-12">
                    <ul class="ulDesign1">
                        <li v-for="question in questionsTypes" :key="question">
                            <p style="display: contents">{{question}}</p>
                        </li>
                    </ul>
                </div>
            </div>

            <div v-if="template.matrial_status === 1" class="px-0">
                <p class="px-0" style="color: #E37450">Template Material</p>
                <div class="d-flex flex-wrap flexDesign">
                    <div class="w-100 tabContent4">
                        <ul class="ulDesign list-group" v-if="template.files.length > 0">
                            <li class="file-container" v-for="fileLink in template.files" :key="fileLink.id">
                                <img class="file-img-icon" title="View Matrial"
                                     @click="viewHandler($event,fileLink.file, fileLink.type, fileLink.fileName)"
                                     :src="getFileIcon(1,fileLink.fileName)" width="50" height="50" alt="">
                                <br>
                                <span class="text-center file-name">{{fileLink.fileName}}</span>
                            </li>
                        </ul>
                        <ul v-else>
                            No Files
                        </ul>
                    </div>
                    <div class="w-100">
                    <p class="px-0" style="color: #E37450">Template Videos</p>
                    <div class="w-100 tabContent4">

                        <ul class="ulDesign list-group" v-if="template.videoLinks.length > 0">
                            <li v-for="video in template.videoLinks" :key="video.id">
                                <iframe style="pointer-events: none;" width="150" height="100"
                                        :src="video.file">
                                </iframe>
                                <br>
                                <div class="text-center">
                                    <button @click="PreviewVideo(video)" class="styleBtnPreview btn">Preview</button>
                                </div>
                            </li>
                        </ul>
                        <ul v-else>
                            No Video Link
                        </ul>
                    </div>
                    </div>
                </div>
            </div>

            <div v-else></div>
        </div>
    </div>

    <PreviewVideo :video="videoPlayed" v-if="isShown" @close-modal="isShown = false"/>

</template>

<script>
    import moment from 'moment';
    import competition from "../../../api-services/competition";
    import getFileExt from "../../../helpers/getFileExt";
    import VueCountdown from '@chenfengyuan/vue-countdown';
    import getQuestionType from "../../../helpers/getQuestionType";
    import getQuestionName from "../../../helpers/getQuestionName";
    import PreviewVideo from "../../components/PreviewVideo";

    export default {
        name: 'viewUser-competition',
        data() {
            return {
                startCountflag: false,
                isCompetionEnded: false,
                isCompetitionEndedLast:false,
                status:'',
                time: null,
                start: null,
                end: null,
                d: null,
                questionsTypes:[],
                questionsCat:[],
                competition: {
                    start_date: null,
                    end_date: null,
                    start_time: null,
                    end_time: null,
                    duration: null,
                    is_submited:0,
                    is_user_submit:0,
                },
                videoPlayed:null,
                isShown:false,
                template: {
                    description: null,
                    matrial_status:null,
                    questions: [],
                    material: [],
                    files: [],
                    videoLinks: [],
                    slides:[]
                },
                data: {
                    questions: [],
                    slides: [],
                },

                diffTime: null,

            }
        },
        components: {
            VueCountdown,
            PreviewVideo
        },
        mounted() {
            this.showCompetition();
            console.log(this.template);
        },
        methods: {
            questionName(type){
                return getQuestionName(type);
            },
            PreviewVideo(video){
                this.isShown = true;
                this.videoPlayed = video.file;
            },
            getFileIcon(type, fileName) {
                const ext = getFileExt(type, fileName);
                return require(`../../../assets/images/${ext}.png`) ? require(`../../../assets/images/${ext}.png`) :  require(`../../../assets/images/document.png`);

            },
            async viewHandler(e, filePath, fileType = null, fileName = null) {
                // const link = document.createElement("a");
                // link.href = filePath;
                // link.download = `${fileName}`;
                // link.click();

                window.open(`${process.env.VUE_APP_AWS_STREEM_URL}/materials/${filePath}`)
            },
            async showCompetition() {
                try {
                    const id = this.$route.params.id;
                    const response = await competition.show(id);
                    console.log(response.data.data);

                    this.competition.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');;
                    this.competition.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');;
                    this.competition.start_time = response.data.data.start_time.slice(0,5);
                    this.competition.end_time = response.data.data.end_time.slice(0,5);
                    this.competition.duration = response.data.data.duration;
                    this.competition.is_submited = response.data.data.is_submited;
                    this.competition.is_submited = response.data.data.is_submited;
                    this.template.description = response.data.data.template.description;
                    this.template.matrial_status = response.data.data.template.matrial_status;
                    this.template.questions = response.data.data.template.questions;
                    this.template.slides = response.data.data.template.slides;
                    this.data.questions = response.data.data.template.questions;
                    this.data.slides = response.data.data.template.slides;
                    this.template.material = response.data.data.template.attachments;

                    this.template.files = this.template.material.filter(function (value) {
                        return value.type === "1";
                    });

                    this.template.videoLinks = this.template.material.filter(function (value) {
                        return value.type === "2";
                    });

                    for(let i = 0 ; i < this.template.questions.length ; i++){
                        if (this.questionsTypes.indexOf(this.template.questions[i].title) === -1) {
                            this.questionsTypes.push(this.template.questions[i].title);
                        }
                    }

                    for(let i = 0 ; i < this.template.slides.length ; i++){
                        this.questionsTypes.push(this.template.slides[i].title);
                    }


                    this.questionsCat = this.questionsTypes.filter((c, index) => {
                        return this.questionsTypes.indexOf(c) === index;
                    });

                    var today = new Date();
                    var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                    var time = '';

                    if(today.getHours() < 10){
                        time = '0'+today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    }else{
                        time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    }
                    
                    if(this.competition.end_time <= time){
                        this.isCompetitionEndedLast = true;
                    }

                    if(this.competition.end_date === moment(date).format('YYYY-MM-DD') && this.competition.end_time === time){
                        this.status= 'Ended';
                    }


                    this.time = moment(this.competition.start_date).format('YYYY-MM-DD') + 'T' + this.competition.start_time;
                    console.log('tt => ', this.time)
                    let now = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
                    console.log('tt => ', now)


                    this.diffTime = moment.duration(moment(this.time).diff(moment(now))).as('minutes') * 60000;
                    console.log('tt => ', this.diffTime)
                    this.start = moment(this.competition.start_date).format('D MMM YYYY') + 'T' + this.competition.start_time;
                    this.end = moment(this.competition.end_date).format('D MMM YYYY') + 'T' + this.competition.end_time;

                    if(this.competition.duration === null){
                        let startTime = moment(this.competition.start_time, "HH:mm:ss a");
                        let endTime = moment(this.competition.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.d = (hours+minutes);
                    }

                    console.log(this.time);
                    console.log(this.start);
                    console.log(this.end);
                    console.log(this.d);
                    this.startCountflag = true;

                } catch (e) {
                    console.log(e);
                }
            },
            StartCompetition() {
                this.$router.push({path: `/competition/${this.$route.params.id}/start`})
            },
            onCountdownStart(){
                console.log('start')
            },
            async onCountdownEnd() {
                console.log('end')
                this.isCompetionEnded = true;
                this.status = 'Started';
            }
        }
    }
</script>


<style scoped>
    .cssCheckLight{
        color: var(--main-color);
    }
    .styleBtnPreview{
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
    }
    .styleBtnPreview:hover{
        background-color: var(--btn-bg-color);
        color: var(--btn-text-color);
    }
    .file-container{
        width: 100px;
        height: 45%;
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        cursor: pointer;
    }
    .file-name {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 130px;
        height: 2.2em;
        align-self: flex-start;
        white-space: nowrap;
    }
    .list-group {
        flex-direction: row;
    }

    .flexDesign {
        gap: 60px;
        padding-right: 0px;
    }

    .tabContent4 {
        display: flex;
        padding: 30px;
        width: 47%;
        background-color: #022F43;
        border: 1px solid #6F8896;
        height: 280px;
        border-radius: 10px;
        overflow: auto;
    }

    .ulDesign1 {
        list-style: none;
        display: flex;
        flex-wrap: wrap;
        gap: 100px;
    }

    .ulDesign {
        list-style: none;
    }

    .ulDesign1 li::before {
        content: "\2022";
        color: #e65c00;
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 1em;
        margin-left: -1em;
    }

    .ulDesign {
        display: flex;
        flex-wrap: wrap;
        gap: 50px;
    }

    .minsCss h5 {
        font-size: 29px;
    }

    .minsCss {
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 75px;
        height: 75px;
        border-radius: 5px;
    }

    .columnCss {
        color: #E95626;
        font-size: 44px;
        font-weight: bold;
    }

    .daysCss h5 {
        font-size: 29px;
    }

    .daysCss {
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 70px;
        height: 75px;
        border-radius: 5px;
    }

    .designRowOrga {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 0;
        margin-bottom: 20px;
    }

    .btnOrganization button {
        background-color: #E95626;
        color: #fff;
        border: none;
        border-radius: 5px;
        justify-content: end;
        align-content: center;
        padding: 10px;
    }

    .tabContent4 {
        display: flex;
        padding: 30px;
        width: 48%;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }

    .tabContent3 {
        display: flex;
        padding: 30px;
        height: 10vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }

    .tabContent2 .desc {
        height: 100px;
        overflow: auto;
    }

    .tabContent2 {
        display: flex;
        padding: 30px;
        height: 18vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }

    .tabContent1 {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 30px;
        height: 18vh;
        width: 100%;
        overflow-y: auto;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 10px;
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px)  {
        .tabContent1{
            height: 22vh;
        }
        .tabContent3{
            height: 13vh;
        }
    }

    @media only screen and (max-width: 1170px) and (min-width: 1024px)  {
        .tabContent3{
            height: 17vh;
        }
    }

    .tabContent {
        display: flex;
        padding: 30px;
        /*height: 80vh;*/
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border: 1px solid var(--table-border);
        border-radius: 20px;
    }

    .file-img-icon {
        cursor: pointer;
    }
</style>